var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22266 4.38461C9.05469 4.38461 10.0977 3.80483 10.7188 3.03179C11.2812 2.33121 11.6914 1.35283 11.6914 0.374443C11.6914 0.241576 11.6797 0.108709 11.6562 0C10.7305 0.0362365 9.61719 0.640177 8.94922 1.44946C8.42188 2.06548 7.94141 3.03179 7.94141 4.02225C7.94141 4.1672 7.96484 4.31214 7.97656 4.36046C8.03516 4.37254 8.12891 4.38461 8.22266 4.38461ZM5.29297 19C6.42969 19 6.93359 18.2149 8.35156 18.2149C9.79297 18.2149 10.1094 18.9758 11.375 18.9758C12.6172 18.9758 13.4492 17.7921 14.2344 16.6325C15.1133 15.3039 15.4766 13.9994 15.5 13.939C15.418 13.9148 13.0391 12.9123 13.0391 10.0979C13.0391 7.65798 14.9141 6.5588 15.0195 6.47425C13.7773 4.63827 11.8906 4.58996 11.375 4.58996C9.98047 4.58996 8.84375 5.45963 8.12891 5.45963C7.35547 5.45963 6.33594 4.63827 5.12891 4.63827C2.83203 4.63827 0.5 6.59504 0.5 10.2912C0.5 12.5861 1.36719 15.014 2.43359 16.5842C3.34766 17.9129 4.14453 19 5.29297 19Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLoginIcon);
export default __webpack_public_path__ + "static/media/appleLoginIcon.6c12a5b1b2a83471905f5c081cc73377.svg";
export { ForwardRef as ReactComponent };